import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom, { Fragment } from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { app } from "../../../Frame/App";
import { WidgetStatistic, TemplateStatus  } from "../Widgets/WidgetStatistic";
import { ITableColumn } from "../../Table/ITableColumn";
import { TableColumnTypes } from "../../Table/TableColumnTypes";
import { TableColumnAlign } from "../../Table/TableColumnAlign";
import { MsoTable } from "../../Table/MsoTable";
import { EditTypes } from "../../Table/EditTypes";
import { StatisticModel } from "../Models/StatisticModel";
import { PagePopup } from "../../PagePopup";

export type WidgetStatisticComponentProps = {
    widget: WidgetStatistic;
}

export class WidgetStatisticComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetStatisticComponentProps;
    private table: MsoTable;
    private data: StatisticModel[] = [];

    constructor(props: WidgetStatisticComponentProps) {
        super(props);
    }

    createAmpel(color: string): HTMLElement {
        return <div className={"ampel ampel-" + color}> </div>;
    }

    private tableBeforeAddColumns = (columns: ITableColumn[]) => {
        /*** Total column ***/
        let colTotal: ITableColumn = {
            dataField: "total",
            headerText: Resources['WidgetClient'].total,
            headerCssClass: "text-center",
            cssClass:"hover-item",
            number: columns.length,
            type: TableColumnTypes.Int,
            width: 70,
            align: TableColumnAlign.Center,
            isEditable: false,
            isFilterable: false,
            fireOnCellClick: true
        };
        if (this.props.widget.props.showTotal)
            columns.unshift(colTotal);

        /*** Open column ***/
        let colOpen: ITableColumn = {
            dataField: "open",
            headerText: Resources.Common["ampelBlue"],
            headerCssClass: "text-center",
            cssClass: "hover-item",
            number: columns.length,
            type: TableColumnTypes.Int,
            width: 70,
            align: TableColumnAlign.Center,
            isEditable: false,
            isFilterable: false,
            fireOnCellClick: true
        };
        if (this.props.widget.props.showOpen)
            columns.unshift(colOpen);

        /*** status columns ***/
        let colDelayed: ITableColumn = {
            dataField: "delay",
            toolTip: Resources.Common["ampelRed"],
            headerElement: this.createAmpel("red"),
            headerCssClass: "text-center",
            cssClass: "delay-item",
            number: columns.length,
            type: TableColumnTypes.Int,
            width: 70,
            align: TableColumnAlign.Center,
            isEditable: false,
            isFilterable: false,
            fireOnCellClick: true
        };
        if (this.props.widget.props.statusDelayed || this.props.widget.props.statusAll)
            columns.unshift(colDelayed);

        let colDueSoon: ITableColumn = {
            dataField: "dueSoon",
            toolTip: Resources.Common["ampelYellowSoon"],
            headerElement: this.createAmpel("yellow"),
            headerCssClass: "text-center",
            cssClass: "soon-item",
            number: columns.length,
            type: TableColumnTypes.Int,
            width: 70,
            align: TableColumnAlign.Center,
            isEditable: false,
            isFilterable: false,
            fireOnCellClick: true
        };
        if (this.props.widget.props.statusDueSoon || this.props.widget.props.statusAll)
            columns.unshift(colDueSoon);

        let colInProgress: ITableColumn = {
            dataField: "inProgress",
            toolTip: Resources.Common["inPlan"],
            headerElement: this.createAmpel("blue"),
            headerCssClass: "text-center",
            cssClass: "progress-item",
            number: columns.length,
            type: TableColumnTypes.Int,
            width: 70,
            align: TableColumnAlign.Center,
            isEditable: false,
            isFilterable: false,
            fireOnCellClick: true
        };
        if (this.props.widget.props.statusInPlan || this.props.widget.props.statusAll)
            columns.unshift(colInProgress);

        let colClosed: ITableColumn = {
            dataField: "closed",
            toolTip: Resources.Common["ampelGreen"],
            headerElement: this.createAmpel("green"),
            headerCssClass: "text-center",
            cssClass: "closed-item",
            number: columns.length,
            type: TableColumnTypes.Int,
            width: 70,
            align: TableColumnAlign.Center,
            isEditable: false,
            isFilterable: false,
            fireOnCellClick: true,
        };
        if (this.props.widget.props.statusClosed || this.props.widget.props.statusAll)
            columns.unshift(colClosed);

        let colOnHold: ITableColumn = {
            dataField: "onHold",
            toolTip: Resources.Common["ampelOnHold"],
            headerElement: this.createAmpel("onHold"),
            headerCssClass: "text-center",
            cssClass: "onhold-item",
            number: columns.length,
            type: TableColumnTypes.Int,
            width: 70,
            align: TableColumnAlign.Center,
            isEditable: false,
            isFilterable: false,
            fireOnCellClick: true
        };
        if (this.props.widget.props.statusOnHold || this.props.widget.props.statusOnHold)
            columns.unshift(colOnHold);
        
        columns.sort((x, y) => x.number > y.number ? 1 : -1)
    }

    private Columns: ITableColumn[] = [
        { type: TableColumnTypes.String, dataField: "ereignisName", number: 1, headerText: "Name", cssClass: "title-item", fixedWidth: "200px", align: TableColumnAlign.Left, fireOnCellClick: true },
    ]

    public element: HTMLElement =
        <div className="widget Background-Blur-90-MSO">
            <div className="title-row">
                <div className="title mr-auto">{(this.props.widget.props.title[`value${app.languageUpperCase}`] && this.props.widget.props.title[`value${app.languageUpperCase}`].trim().length > 0) ? this.props.widget.props.title[`value${app.languageUpperCase}`] : this.props.widget.props.title[`value${app.defaultLanguageUpperCase}`]}</div>
            </div>
            <div className="content-row">
                {this.renderTable()}
            </div>
        </div>;

    renderTable(): HTMLElement {
        let rootId = "widget_statistik_" + app.createGuid();
        let div: HTMLElement = <div id={rootId} className="widget-statistik overflow-auto"></div>;
        if (this.props.widget.props.templateIds) {
            this.table = new MsoTable(div, {
                loadOnCreate: false,
                enableScroll: true,
                rowsPerPage:100,
                fixedLayout: true,
                fixedHeader: true,
                idField: "id",
                settingsName: "statisticList",
                editType: EditTypes.None,
                onCellClick: (field: string, id: number): void => {
                    let model = this.table.getRowModel(id.toString());
                    let count: number = 0;
                    let popupTitle = Resources['WidgetClient'].searchResultLabel + " : " + model["ereignisName"] + " - ";
                    if (field == "total" || field == "ereignisName") {
                        count = model["total"];
                        popupTitle = popupTitle + Resources['WidgetClient'].total + ` (${model["total"]})`;
                    }
                    if (field == "open") {
                        count = model["open"];
                        popupTitle = popupTitle + Resources.Common["ampelBlue"] + ` (${model["open"]})`;
                    }
                    if (field == "delay") {
                        count = model["delay"];
                        popupTitle = popupTitle + Resources.Common["ampelRed"] + ` (${count})`;
                    }
                    if (field == "closed") {
                        count = model["closed"];
                        popupTitle = popupTitle + Resources.Common["ampelGreen"] + ` (${count})`;
                    }
                    if (field == "dueSoon") {
                        count = model["dueSoon"];
                        popupTitle = popupTitle + Resources.Common["ampelYellowSoon"] + ` (${count})`;
                    }
                    if (field == "inProgress") {
                        count = model["inProgress"];
                        popupTitle = popupTitle + Resources.Common["inPlan"] + ` (${count})`;
                    }

                    if (field == "onHold") {
                        count = model["onHold"];
                        popupTitle = popupTitle + Resources.Common.ampelOnHold + ` (${count})`;
                    }

                    let popup: PagePopup;
                    if (this.props.widget.props.categoryId) {
                        popup = new PagePopup({
                            url: app.resolveUrl(`~/Measures/WidgetSearchResult?templateId=${0}&categoryContentId=${id}&measureState=${field}`),
                            fullScreen: false,
                            resultId: 0,
                            showCloseButton: true
                        });
                    } else {
                        popup = new PagePopup({
                            url: app.resolveUrl(`~/Measures/WidgetSearchResult?templateId=${id}&categoryContentId=0&measureState=${field}`),
                            fullScreen: false,
                            resultId: 0,
                            showCloseButton: true
                        });
                    }

                    popup.setTitle(popupTitle);
                }
            });

        }

        return div;
    }

    public render(): HTMLElement {
        this.props.widget.setGridPosition();
        this.loadData();
        return this.element;
    }

    
    private loadData() {
        if (this.props.widget.props.templateIds) {
            // load data
            $.ajax({
                type: "POST",
                url: app.resolveUrl("~/api/widget/getStatisticData"),
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({ templateIds: this.props.widget.props.templateIds, categoryId: this.props.widget.props.categoryId }),
                success: (data: StatisticModel[]) => {
                    this.data = data;
                    this.table.props.onBeforeCreateColumns = this.tableBeforeAddColumns;
                    this.table.createAll(this.Columns, this.data, null, null);
                },
                error: ((response) => {
                    app.addError(response.statusText + ": " + response.responseText);
                })
            });
        }
    }

}